import React from "react";
import {ClaimStatus, claimStatusColor} from "../../../models/claims/claims";
import {StatusTag} from "../../core/commons/status/status";

interface ClaimStatusProps {
    status: ClaimStatus;
    large?: boolean;
}
export const ClaimsStatus: React.FC<ClaimStatusProps> = ({status, large = false}) => {
    return (
        <StatusTag<ClaimStatus> status={status} colorsMap={claimStatusColor} large={large} prefix="CLAIMS.CLAIM.STATUS"/>
    )
}
